/*
 * Newsletter sign-up forms (snippets/klaviyo-signup.liquid).
 * Subscribes via Klaviyo's client Subscriptions API into the market's list, so the
 * list's opt-in setting (single/double) and welcome flow apply exactly as for pop-ups.
 */
(function () {
  if (window.BABKlaviyoSignup) return;
  window.BABKlaviyoSignup = true;

  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  // National number + market dial code → E.164 (e.g. "20 12 34 56" → "+4520123456").
  function normalizePhone(form) {
    const input = form.querySelector('input[name="phone"]');
    if (!input) return '';
    let raw = (input.value || '').replace(/[^\d+]/g, '');
    if (!raw) return '';
    if (raw.startsWith('00')) raw = '+' + raw.slice(2);
    if (!raw.startsWith('+')) raw = (input.dataset.dial || '+45') + raw.replace(/^0+/, '');
    return /^\+\d{8,15}$/.test(raw) ? raw : 'invalid';
  }

  // Collapsed mobile forms: reveal the optional fields once the e-mail field is used.
  document.addEventListener('focusin', (e) => {
    if (e.target.type !== 'email') return;
    const wrap = e.target.closest('.kl-signup--collapse-mobile');
    if (wrap) wrap.classList.add('is-expanded');
  });

  // Show the SMS consent box once a number is typed.
  document.addEventListener('input', (e) => {
    if (e.target.name !== 'phone') return;
    const form = e.target.closest('[data-kl-form]');
    const box = form && form.querySelector('[data-kl-sms-consent]');
    if (box) box.hidden = e.target.value.trim() === '';
  });

  async function subscribe(form, email, allowPhone) {
    const firstName = ((form.querySelector('input[name="first_name"]') || {}).value || '').trim();
    const birthday = ((form.querySelector('input[name="birthday"]') || {}).value || '').trim();
    const properties = { signup_source: form.dataset.source || 'Website', signup_market: form.dataset.market || '' };
    // Same property names as the Klaviyo pop-ups ("Name", "Birthday"); birthday as YYYY-MM-DD.
    if (firstName) properties.Name = firstName;
    if (birthday) properties.Birthday = birthday;
    const profileAttrs = { email: email, properties: properties };
    if (firstName) profileAttrs.first_name = firstName;
    // Phone is only sent (= SMS subscription) with the separate SMS consent box ticked.
    const phone = normalizePhone(form);
    const smsBox = form.querySelector('input[name="sms_consent"]');
    if (allowPhone !== false && phone && phone !== 'invalid' && smsBox && smsBox.checked) profileAttrs.phone_number = phone;
    const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(form.dataset.company)}`;
    const body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: form.dataset.source || 'Website',
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttrs,
            },
          },
        },
        relationships: { list: { data: { type: 'list', id: form.dataset.list } } },
      },
    };
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify(body),
    });
    if (!res.ok && res.status !== 202) throw new Error('klaviyo ' + res.status);
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-kl-form]');
    if (!form) return;
    e.preventDefault();

    const wrap = form.closest('[data-kl-signup]');
    const input = form.querySelector('input[type="email"]');
    const btn = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[data-kl-error]');
    const email = (input.value || '').trim();
    

    const smsError = form.querySelector('[data-kl-sms-error]');
    error.hidden = true;
    if (smsError) smsError.hidden = true;
    if (!EMAIL_RE.test(email)) {
      error.hidden = false;
      input.focus();
      return;
    }
    // A number without SMS consent (or an invalid number) is not sent — ask the visitor.
    const phone = normalizePhone(form);
    const smsBox = form.querySelector('input[name="sms_consent"]');
    if (phone && (phone === 'invalid' || !smsBox || !smsBox.checked)) {
      if (smsError) smsError.hidden = false;
      (phone === 'invalid' ? form.querySelector('input[name="phone"]') : smsBox).focus();
      return;
    }

    btn.disabled = true;
    try {
      try {
        await subscribe(form, email);
      } catch (err) {
        // If Klaviyo rejects the phone number (e.g. SMS not enabled for that country),
        // never lose the email sign-up — retry without the phone number.
        if (!form.querySelector('input[name="phone"]') || !form.querySelector('input[name="phone"]').value.trim()) throw err;
        await subscribe(form, email, false);
      }
      // Tie this browser to the profile so Klaviyo stops showing sign-up pop-ups to them.
      try {
        window.klaviyo && window.klaviyo.identify && window.klaviyo.identify({ email: email });
      } catch (err) {}
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'newsletter_signup', signup_source: form.dataset.source || '', signup_market: form.dataset.market || '' });
      form.hidden = true;
      wrap.querySelector('[data-kl-done]').hidden = false;
    } catch (err) {
      error.hidden = false;
      btn.disabled = false;
    }
  });
})();
